<template>
  <modal
    :exibir="exibir"
    @fechar="fecharModal"
    titulo="Adicionar CPF"
    :campos="$refs"
    id="modalAdicionarCpf"
    :ocultarRodape="true"
  >
    <input-mask
      ref="cpf"
      type="text"
      v-model="cpf"
      :label="$t('PESSOAS.CPF')"
      :mask="['###.###.###-##']"
      :validate="validarCpfCnpj"
      required
      placeholder="Digite apenas números"
    />
    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="fecharModal()">
        {{ $t('GERAL.FECHAR') }}
      </b-button>

      <b-button variant="primary" @click="adicionarCpf" :disabled="!validarCpfCnpj">
        Salvar
      </b-button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue';
import PessoaService from '@/common/services/pessoa/pessoa.service';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

import { InputMask } from '@/components/inputs';

export default {
  components: {
    Modal, InputMask
  },
  props: {
    exibir: { type: Boolean, default: false },
    pessoaSelecionada: { type: Object, default: null },
  },
  data() {
    return {
      cpf: '',
    };
  },
  computed: {
    validarCpfCnpj() {
      let checagemCpf;
      if (this.cpf) {
        checagemCpf = helpers.validarCpfCnpj(this.cpf);
      }
      return checagemCpf;
    },
  },
  methods: {
    adicionarCpf() {
      PessoaService.adicionarCpf(this.pessoaSelecionada.pessoaId, this.cpf).then(({ data }) => {
        this.$emit('fechar', data.data);
      }).catch(error => {
        mensagem.showErrors(error);
      }).finally(() => {
        this.cpf = '';
      })
    },
    fecharModal() {
      this.cpf = '';
      this.$emit('fechar');
    },
  },
};
</script>
